// import { jwtDecode } from 'jwt-decode'; // Correct import
// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import '../Styles/AppBar.css'; // Import the CSS file for styling
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faBars,
//   faSignOutAlt,
//   faChartBar,
//   faMoneyBill,
//   faFileInvoice,
//   faUpload,
//   faUserFriends,
//   faUniversity,
//   faCalendarAlt,
//   faFileAlt,
// } from '@fortawesome/free-solid-svg-icons';

// const AppBar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [walletBalance, setWalletBalance] = useState(null);
//   const [userName, setUserName] = useState(null);
//   const navigate = useNavigate();

//   // Fetch token and wallet balance

//   useEffect(() => {
//     const tokenData = localStorage.getItem('b2bAuthToken');
//     if (tokenData) {
//       try {
//         const parsedData = JSON.parse(tokenData);
//         const token = parsedData.token;
  
//         // Decode JWT manually (only the payload part)
//         const decodedPayload = jwtDecode(token); // Using jwtDecode function
  
//         const userId = decodedPayload.id; // Extracting the 'id' from the payload
//         console.log('User ID:', userId);
  
//         fetchWalletBalance(userId); // Pass userId to fetch wallet balance
  
//       } catch (error) {
//         console.error('Error parsing token data:', error);
//       }
//     } else {
//       console.error('No token data found in localStorage');
//     }
//   }, []);
  
  
// let phoneNumber;
//   const fetchWalletBalance = async (id) => {
//     try {
//       // Replace `API_URL` with your wallet balance API endpoint
//       const response = await fetch(`https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${id}`, {
//         method: 'POST', // POST request to fetch wallet balance
//         headers: {
//           'Content-Type': 'application/json',
//           // Add any required headers (like Authorization) if needed
//         },
//       });
  
//       if (response.ok) {
//         const data = await response.json();
        
//         // Access wallet balance from the 'data' field in the API response
//         const walletBalance = data.data.wallet; // Adjusted to get the 'wallet' field from the 'data' object
//         const userName = data.data.fullName;
//         phoneNumber=data.data.phoneNumber;
//         console.log("phoneNumber of agency is",phoneNumber);
//         setUserName(userName);
//         setWalletBalance(walletBalance || '0'); // Fallback to '0' if no wallet balance is found
//         console.log("wallet balance is", walletBalance);
//       } else {
//         console.error('Failed to fetch wallet balance:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Error fetching wallet balance:', error);
//     }
//   };
  

//   // Toggle menu visibility
//   const toggleMenu = () => {
//     setMenuOpen(!menuOpen);
//   };

//   // Close menu when clicking outside
//   useEffect(() => {
//     const closeMenu = (e) => {
//       if (!e.target.closest('.navbar')) {
//         setMenuOpen(false);
//       }
//     };
//     document.addEventListener('click', closeMenu);
//     return () => document.removeEventListener('click', closeMenu);
//   }, []);

//   return (
//     <div className="navbar">
//       {/* App Title */}
//       <h3 className="appbar-title" onClick={() => navigate(`/flightSearch`)}>
//         MMSTourism
//       </h3>

//       {/* Right Side Buttons */}
//       <div className="right-side-buttons">
//         {/* Pax Calendar Button */}
//         <button className="right-side-button" onClick={() => navigate(`/airpaxcalendar`)}>
//           <FontAwesomeIcon icon={faCalendarAlt} />
//           <span>Pax Calendar</span>
//         </button>

//         {/* Wallet Dropdown */}
//         <div className="relative inline-block">
//           <select
//             className="wallet-dropdown px-4 py-2 right-side-button"
//             onChange={(e) => navigate(e.target.value)}
//             defaultValue="wallet"
//           >
//             <option value="wallet" disabled>
//               Wallet Balance ₹{walletBalance}
//             </option>
//             <option value="/recharge">Add Balance</option>
//           </select>
//         </div>

//       </div>

//       {/* Menu Icon */}
//       <FontAwesomeIcon className="icon-style" icon={faBars} onClick={toggleMenu} />

//       {/* Sidebar Menu */}
//       {menuOpen && (
//         <div className="sidebar-menu">
//           <div className="sidebar-title">{userName}</div>
//           <div className="menu-items">
//             <div className="menu-item">
//               <FontAwesomeIcon icon={faChartBar} onClick={() => {navigate(`/solidticket`);setMenuOpen(false)}} />
//               <span>Sales Record</span>
//             </div>
//             <div className="menu-item">
//               <FontAwesomeIcon icon={faFileInvoice} onClick={() => {navigate(`/account`); setMenuOpen(false)}} />
//               <span>Accounts Ledger</span>
//             </div>
           
//             <div className="menu-item">
//               <FontAwesomeIcon icon={faUniversity} onClick={() => {navigate(`/bank_details`);setMenuOpen(false)}} />
//               <span>Bank Details</span>
//             </div>
//             <div className="menu-item">
//               <FontAwesomeIcon icon={faUserFriends} onClick={() => {navigate(`/group_query`);setMenuOpen(false)}} />
//               <span>Group Query</span>
//             </div>
//             <div className="menu-item">
//               <FontAwesomeIcon icon={faCalendarAlt} onClick={() => {navigate(`/airpaxcalendar`); setMenuOpen(false)}} />
//               <span>Pax Calendar</span>
//             </div>
//             <div className="menu-item">
//               <FontAwesomeIcon icon={faFileAlt} onClick={() => {navigate(`/recharge`);setMenuOpen(false)}} />
//               <span>Online Recharge</span>
//             </div>
//           </div>
//           <div className="footer">
//             <Link
//   to="/change-password"
//   state={{phoneNumber }}
// >
//   Change Password
// </Link>

//             {/* <Link to="/change-password">Change Password</Link> */}
//             <Link to="/" className="logout-link">
//               <FontAwesomeIcon icon={faSignOutAlt} /> Logout
//             </Link>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AppBar;
//-----------------------18-06-2025-----------------
import { jwtDecode } from 'jwt-decode';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Styles/AppBar.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import logo from "../Images/logo1.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars, faSignOutAlt, faChartBar, faMoneyBill, faFileInvoice, faUpload,
  faUserFriends, faUniversity, faCalendarAlt, faFileAlt,faUser
} from '@fortawesome/free-solid-svg-icons';

const AppBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [walletBalance, setWalletBalance] = useState(null);
  const [userName, setUserName] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null); // <-- State for phoneNumber

  const navigate = useNavigate();

  useEffect(() => {
    const tokenData = localStorage.getItem('b2bAuthToken');
    if (tokenData) {
      try {
        const parsedData = JSON.parse(tokenData);
        const token = parsedData.token;
        const decodedPayload = jwtDecode(token);
        const userId = decodedPayload.id;
        fetchWalletBalance(userId);
      } catch (error) {
        console.error('Error parsing token data:', error);
      }
    } else {
      console.error('No token data found in localStorage');
    }
  }, []);

  const fetchWalletBalance = async (id) => {
    try {
      const response = await fetch(`https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/a1b1c1d16/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setWalletBalance(data.data.wallet || '0');
        setUserName(data.data.fullName);
        setPhoneNumber(data.data.phoneNumber); // <-- Set phoneNumber in state
        console.log("Phone number of agency is", data.data.phoneNumber);
      } else {
        console.error('Failed to fetch wallet balance:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching wallet balance:', error);
    }
  };

  const toggleMenu = () => setMenuOpen(!menuOpen);

  useEffect(() => {
    const closeMenu = (e) => {
      if (!e.target.closest('.navbar')) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('click', closeMenu);
    return () => document.removeEventListener('click', closeMenu);
  }, []);

  return (
    <div className="navbar">
      {/* <img
  src={logo}
  alt="MMSTourism"
  className="appbar-logo"
  onClick={() => navigate("/flightSearch")}
/> */}
<div className="appbar">
  <img
    src={logo}
    alt="MMSTourism"
    className="appbar-logo"
    onClick={() => navigate("/flightSearch")}
  />
</div>


      {/* <h3 className="appbar-title" onClick={() => navigate(`/flightSearch`)}>
        MMSTOURISM
      </h3> */}
{/* <h3 className="appbar-title" onClick={() => navigate(`/flightSearch`)}>
  <span className="brand-main">MMS</span>
  <span className="brand-sub">TOURISM</span>
</h3> */}

      <div className="right-side-buttons">
        {/* <button className="right-side-button" onClick={() => navigate(`/airpaxcalendar`)}>
          <FontAwesomeIcon icon={faCalendarAlt} />
          <span>Pax Calendar</span>
        </button> */}

        <div className="relative inline-block">
          <select
            className="wallet-dropdown px-4 py-2 right-side-button"
            onChange={(e) => navigate(e.target.value)}
            defaultValue="wallet"
          >
            <option value="wallet" disabled>
              Wallet Balance ₹{walletBalance}
            </option>
            {/* <option value="/recharge">Add Balance</option> */}
          </select>
        </div>
      </div>

      <FontAwesomeIcon className="icon-style" icon={faBars} onClick={toggleMenu} />

      {menuOpen && (
        <div className="sidebar-menu">
          <div className="sidebar-title">{userName}</div>
     
          <div className="menu-items">
            <div className="menu-item" onClick={() => {navigate(`/solidticket`); setMenuOpen(false);}}>
              <FontAwesomeIcon icon={faChartBar} />
              <span>Sales Record</span>
            </div>
            {/* <div className="menu-item" onClick={() => {navigate(`/account`); setMenuOpen(false);}}>
              <FontAwesomeIcon icon={faFileInvoice} />
              <span>Accounts Ledger</span>
            </div> */}
            <div className="menu-item" onClick={() => {
  const tokenData = localStorage.getItem('b2bAuthToken');
  const token = tokenData ? JSON.parse(tokenData).token : null;
  const decoded = token ? jwtDecode(token) : null;
  const agentId = decoded?.id;

  if (agentId) {
    navigate('/account', { state: { agentId } }); // ✅ pass as state
  }

  setMenuOpen(false);
}}>
  <FontAwesomeIcon icon={faFileInvoice} />
  <span>Accounts Ledger</span>
</div>

            <div className="menu-item" onClick={() => {navigate(`/bank_details`); setMenuOpen(false);}}>
              <FontAwesomeIcon icon={faUniversity} />
              <span>Bank Details</span>
            </div>
            {/* <div className="menu-item" onClick={() => {navigate(`/group_query`); setMenuOpen(false);}}>
              <FontAwesomeIcon icon={faUserFriends} />
              <span>Group Query</span>
            </div> */}
            {/* <div className="menu-item" onClick={() => {navigate(`/airpaxcalendar`); setMenuOpen(false);}}>
              <FontAwesomeIcon icon={faCalendarAlt} />
              <span>Pax Calendar</span>
            </div> */}
            {/* <div className="menu-item" onClick={() => {navigate(`/recharge`); setMenuOpen(false);}}>
              <FontAwesomeIcon icon={faFileAlt} />
              <span>Online Recharge</span>
            </div> */}
                 <div
  className="menu-item"
  onClick={() => {
    const tokenData = localStorage.getItem("b2bAuthToken");
    const token = tokenData ? JSON.parse(tokenData).token : null;
    const decoded = token ? jwtDecode(token) : null;
    const agentId = decoded?.id;

    if (agentId) {
      navigate("/profile", { state: { agentId } }); // ✅ go to profile page
    }
    setMenuOpen(false);
  }}
>
  <FontAwesomeIcon icon={faUser} /> {/* ✅ profile icon */}
  <span>Profile</span>
</div>
          </div>
          <div className="footer">
            {/* ✅ Only show link if phoneNumber is available */}
            {phoneNumber && (
              <Link to="/change-password" state={{ phoneNumber }}>
                Change Password
              </Link>
            )}
            <Link to="/" className="logout-link">
              <FontAwesomeIcon icon={faSignOutAlt} /> Logout
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppBar;
